module.exports = __webpack_public_path__ + "img/banner-two-day-offer.9c8e65c1.png";